import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ArticlesDashboard from './pages/ArticlesDashboard';

const Articles = () => {
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-file-medical"></i> Articles
                </h1>
                <div>
                    <Link to="/articles/new" className="btn btn-sm btn-outline-primary me-2">
                        <i className="bi bi-plus"></i> Draft New Article
                    </Link>
                    <Link to="/articles/category" className="btn btn-sm btn-outline-secondary">
                        <i className="bi bi-gear"></i> Manage Categories
                    </Link>
                </div>
            </div>
            <Card className="card-padding shadow-sm border-0">
                <Card.Body className="p-3">
                    <div className="d-flex align-items-end justify-content-between gap-2 mb-3">
                        <div className="mb-0 d-flex align-items-center">
                            <i className="bi bi-journal-text text-primary me-2"></i>
                            <h5 className="card-title mb-0" style={{ color: '#012970' }}>
                                Article Library
                            </h5>
                        </div>
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm flex-shrink-0"
                            onClick={() => setSearchPanelOpen((open) => !open)}
                            aria-expanded={searchPanelOpen}
                            title={searchPanelOpen ? 'Hide filters' : 'Show filters'}
                        >
                            <i className="bi bi-funnel me-1"></i>
                            Filter
                        </button>
                    </div>
                    <ArticlesDashboard searchPanelOpen={searchPanelOpen} />
                </Card.Body>
            </Card>
        </div>
    );
};

export default Articles;
